export const second = 1000
export const minute = second * 60
export const hour = minute * 60
export const day = hour * 24
export const week = day * 7
export const wait = (time) => new Promise((res, rej) => {
    setTimeout(() => {
        res()
    }, time || 1000)
})